import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { IClientSectionSettings } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'

import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'

import {
  MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX,
  MANDATORY_CATEGORY_VISIBLE_SUFFIX,
  OVERALL_CATEGORY,
  READONLY_FLAGS,
  TOP_PARTNER_FLAGS,
} from '../../config'
import { IPartnerFlag } from '../../models/IPartnerFlag'

import { getPartnerFlagTag } from './getPartnerFlagTag'

export interface IMandatoryLinesInCategoryCount {
  partnerFlags: string
  formats: IFormActualsTargetsSettings[]
  currentFormat: IFormActualsTargetsSettings
  sectionSettings: Partial<IClientSectionSettings>
  isUnits: boolean
  restrictL3Child: string
}

/**
 * Get MandatoryLines On Current L2/L3 Level
 */
export const getMandatoryLinesInCategoryCount = ({
  partnerFlags,
  formats,
  currentFormat,
  sectionSettings,
  isUnits,
  restrictL3Child,
}: IMandatoryLinesInCategoryCount) => {
  const curSubCat = currentFormat.SubCategory
  const curL3Cat = currentFormat.L3Category
  const curIsL3Overall = curL3Cat === OVERALL_CATEGORY
  const curIsL3 = !!curL3Cat
  const curIsL3Child = curIsL3 && !curIsL3Overall

  const partnerFlagsNames = (partnerFlags || '').split(',')

  let mandatoryCategoriesCount = 0
  formats
    .filter(
      (el) =>
        (!!restrictL3Child &&
          el.SubCategory === restrictL3Child &&
          !!el.L3Category &&
          el.L3Category !== OVERALL_CATEGORY) ||
        (!restrictL3Child &&
          ((!curIsL3Child &&
            el.SubCategory !== OVERALL_CATEGORY &&
            !!el.SubCategory &&
            (!el.L3Category || el.L3Category === OVERALL_CATEGORY)) ||
            (curIsL3Child &&
              el.SubCategory === curSubCat &&
              el.L3Category !== OVERALL_CATEGORY &&
              !!el.L3Category)))
    )
    .forEach((setting) => {
      const partnerFlagsState: IPartnerFlag[] = []

      //
      // TODO: Need to use also setting.SOBMandatoryByFlags flag?
      //
      const mandatoryByFlags = isUnits ? setting.UnitsMandatoryByFlags : setting.MandatoryByFlags
      const settingFlagsNames = (mandatoryByFlags || '').split(',')

      settingFlagsNames
        .filter((el) => !!el)
        .forEach((settingFlag) => {
          let isVisible = true
          let isSkipTransactional = false

          if (!!settingFlag && settingFlag.endsWith(MANDATORY_CATEGORY_VISIBLE_SUFFIX)) {
            settingFlag = settingFlag.substring(0, settingFlag.length - 1)
            isVisible = false
          }
          if (!!settingFlag && settingFlag.endsWith(MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX)) {
            settingFlag = settingFlag.substring(0, settingFlag.length - 1)
            isSkipTransactional = true
          }

          const foundFlags = partnerFlagsState.filter((el) => el.name === settingFlag)
          if (!foundFlags.length) {
            const isPartnerFlag = partnerFlagsNames.includes(settingFlag)
            const isReadonly = READONLY_FLAGS.indexOf(settingFlag) >= 0
            const isTopPartner = TOP_PARTNER_FLAGS.indexOf(settingFlag) >= 0

            const tag = getPartnerFlagTag(settingFlag)
            const flagFromSettings = sectionSettings[tag]

            // Get Flag state from settings (if settings exist)
            let isSettingPresent = false
            let isFlagManuallyEnabled = false
            if (flagFromSettings !== undefined && flagFromSettings !== null) {
              isSettingPresent = true
              isFlagManuallyEnabled = isSectionSettingOn(flagFromSettings)
            }

            // Flags enabled by default for TopPartners and PartnerFlags (if no settings)
            const isForceEnabled = isPartnerFlag && (isTopPartner || !isSettingPresent)
            const isFlagEnabled = isForceEnabled ? true : isFlagManuallyEnabled

            // Force visibility for Partner level flag
            if (isPartnerFlag) {
              isVisible = true
            }

            const disablingUser = sectionSettings[`${tag}-user`]
            const disablingDate = sectionSettings[`${tag}-date`]
            const disablingComment = sectionSettings[`${tag}-comment`]

            partnerFlagsState.push({
              name: settingFlag,
              tag,
              isPartnerFlag,
              isReadonly,
              isTopPartner,
              isEnabled: isFlagEnabled,
              isVisible,
              isSkipTransactional,

              disablingUser,
              disablingDate,
              disablingComment,
            })
          }
        })

      const mandatoryInSubCategoryCount = partnerFlagsState.filter((el) => el.isEnabled).length
      mandatoryCategoriesCount += mandatoryInSubCategoryCount
    })

  return mandatoryCategoriesCount
}
